import { ModuleDTO } from 'src/models/dto/ModuleDTO'
import { downloadAsFile } from 'src/services/downloadAsFile'

/** Reserved column that groups spreadsheet rows into Item Container modules. */
export const CONTAINER_COLUMN = '__container__'

const PLACEHOLDER_REGEX = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g

/** Extract the unique {{placeholder}} token names from a serialized module. */
export function extractPlaceholders(module: ModuleDTO): string[] {
    const json = JSON.stringify(module)
    const found = new Set<string>()
    let match: RegExpExecArray | null
    while ((match = PLACEHOLDER_REGEX.exec(json)) !== null) {
        found.add(match[1])
    }
    PLACEHOLDER_REGEX.lastIndex = 0
    return Array.from(found)
}

/** The template's placeholders plus the reserved container-grouping column. */
export function getSpreadsheetColumns(module: ModuleDTO): string[] {
    const extracted = extractPlaceholders(module)
    return extracted.includes(CONTAINER_COLUMN) ? extracted : [...extracted, CONTAINER_COLUMN]
}

/** Header-only CSV, one column per placeholder, for the author to fill in before importing. */
export function downloadSampleSpreadsheet(columns: string[], moduleName?: string) {
    downloadAsFile(
        new Blob([`${columns.join(',')}\n`], { type: 'text/csv' }),
        `${moduleName ?? 'import'}_sample.csv`
    )
}
